import Vue from 'vue'

// Shared events must not import main.js: importing the entry point can bootstrap
// a second Inertia app and send navigation updates to a detached Vue instance.
export const EventBus = new Vue()
